/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { BusinessUserFull } from './BusinessUserFull';
import {
    BusinessUserFullFromJSON,
    BusinessUserFullFromJSONTyped,
    BusinessUserFullToJSON,
    BusinessUserFullToJSONTyped,
} from './BusinessUserFull';
import type { BusinessPermission } from './BusinessPermission';
import {
    BusinessPermissionFromJSON,
    BusinessPermissionFromJSONTyped,
    BusinessPermissionToJSON,
    BusinessPermissionToJSONTyped,
} from './BusinessPermission';

/**
 * 
 * @export
 * @interface GetBusinessPermissionsResponse
 */
export interface GetBusinessPermissionsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetBusinessPermissionsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<BusinessUserFull>}
     * @memberof GetBusinessPermissionsResponse
     */
    currentUsers: Array<BusinessUserFull>;
    /**
     * 
     * @type {Array<BusinessPermission>}
     * @memberof GetBusinessPermissionsResponse
     */
    authUser: Array<BusinessPermission>;
}

/**
 * Check if a given object implements the GetBusinessPermissionsResponse interface.
 */
export function instanceOfGetBusinessPermissionsResponse(value: object): value is GetBusinessPermissionsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('currentUsers' in value) || value['currentUsers'] === undefined) return false;
    if (!('authUser' in value) || value['authUser'] === undefined) return false;
    return true;
}

export function GetBusinessPermissionsResponseFromJSON(json: any): GetBusinessPermissionsResponse {
    return GetBusinessPermissionsResponseFromJSONTyped(json, false);
}

export function GetBusinessPermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBusinessPermissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'currentUsers': ((json['currentUsers'] as Array<any>).map(BusinessUserFullFromJSON)),
        'authUser': ((json['authUser'] as Array<any>).map(BusinessPermissionFromJSON)),
    };
}

export function GetBusinessPermissionsResponseToJSON(json: any): GetBusinessPermissionsResponse {
    return GetBusinessPermissionsResponseToJSONTyped(json, false);
}

export function GetBusinessPermissionsResponseToJSONTyped(value?: GetBusinessPermissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'currentUsers': ((value['currentUsers'] as Array<any>).map(BusinessUserFullToJSON)),
        'authUser': ((value['authUser'] as Array<any>).map(BusinessPermissionToJSON)),
    };
}

